import { useQuery } from 'react-query';

import { TrapKind, getSnapTrapTraps } from 'api/traps/STTraps/getSnapTrapTraps';

export const useGetSSTraps = (slug: string, kind: TrapKind, enabled: boolean = true) => {
  const queryKey = ['snap-traps', kind, slug];
  const { data, refetch, isLoading } = useQuery(queryKey, () => getSnapTrapTraps(slug, kind), {
    enabled,
    refetchOnWindowFocus: true,
    refetchInterval: 10000,
    refetchOnMount: true,
  });

  return { data, refetch, isLoading };
};

export default useGetSSTraps;
